import React, { useState } from "react";
import Sidebar from "../components/Sidebar";
import OfferDataNavbar from "../components/OfferDataNavbar";
import OfferLeadsTable from "../components/OfferLeadsTable";
const OfferLeads = () => {
  const [sidebarOpen, setSidebarOpen] = useState(true);

  const handleSidebarStateChange = (isOpen) => {
    setSidebarOpen(isOpen);
  };
  return (
    <>
      <Sidebar debarStateChange={handleSidebarStateChange} />
      <OfferDataNavbar />
      <OfferLeadsTable />
    </>
  );
};

export default OfferLeads;
